// Internalized from @videoplatform/css-helpers.
import * as _ from 'lodash';
import * as s from 'underscore.string';

export function cx(classes: Array<string | undefined | null | false>) {
    return classes
        .map((className) => (_.isString(className) ? className : ''))
        .filter((className) => !s.isBlank(className))
        .join(' ');
}
